/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { DetailsRow } from "../../../../components/DetailsRow";
import { AdyenBalanceAccount } from "../../models/adyen-balance-account";
import { colors } from "../../../../components/colors";
import { TableCellHeaderText } from "../../../../components/table-components/TableCellHeaderText";
import { Table } from "../../../../components/table-components/Table";
import { TableRowHeader } from "../../../../components/table-components/TableRowHeader";
import { TableBody } from "../../../../components/table-components/TableBody";
import { TableRow } from "../../../../components/table-components/TableRow";
import { TableCellText } from "../../../../components/table-components/TableCellText";
import { StyledText } from "../../../../assets/typography/typography";
import { buttonWrapperStyle } from "./MutateBusinessLineForm";
import { ButtonInternalLink } from "../../../../components/NewButtons";

const bodyStyle = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 24px;
  padding-bottom: 24px;
  width: 600px;
`;

const bodyWrapperStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow-y: auto;
`;

const tableWrapperStyle = css`
  border: 1px solid ${colors.greyBorder};
  border-radius: 6px;
  overflow: hidden;
`;

type Props = {
  balanceAccount: AdyenBalanceAccount;
};

export const AdyenBalanceAccountDetails = ({ balanceAccount }: Props) => {
  return (
    <div css={bodyWrapperStyle}>
      <div css={bodyStyle}>
        <DetailsRow
          leftText="Description"
          rightText={balanceAccount?.description}
        />
        <DetailsRow leftText="Currency" rightText={balanceAccount?.currency} />
        <StyledText className="bodyTextSemibold mb-0">Balances</StyledText>
        <div css={tableWrapperStyle}>
          <Table>
            <thead>
              <TableRowHeader borderTop={false}>
                <TableCellHeaderText className="pl-3">
                  Currency
                </TableCellHeaderText>
                <TableCellHeaderText>Balance</TableCellHeaderText>
                <TableCellHeaderText>Reserved</TableCellHeaderText>
                <TableCellHeaderText>Available</TableCellHeaderText>
                <TableCellHeaderText>Pending</TableCellHeaderText>
              </TableRowHeader>
            </thead>

            <TableBody borderBottom={false}>
              {balanceAccount.balances.map((balance, i) => {
                return (
                  <TableRow key={i}>
                    <TableCellText>
                      <StyledText
                        className="bodyTextRegular mb-0"
                        color={colors.textPrimary}
                      >
                        {balance.currency}
                      </StyledText>
                    </TableCellText>
                    <TableCellText>
                      <StyledText
                        className="bodyTextRegular mb-0"
                        color={colors.textPrimary}
                      >
                        {balance.balance}
                      </StyledText>
                    </TableCellText>
                    <TableCellText>
                      <StyledText
                        className="bodyTextRegular mb-0"
                        color={colors.textPrimary}
                      >
                        {balance.reserved}
                      </StyledText>
                    </TableCellText>
                    <TableCellText>
                      <StyledText
                        className="bodyTextRegular mb-0"
                        color={colors.textPrimary}
                      >
                        {balance.available}
                      </StyledText>
                    </TableCellText>
                    <TableCellText>
                      <StyledText
                        className="bodyTextRegular mb-0"
                        color={colors.textPrimary}
                      >
                        {balance.pending}
                      </StyledText>
                    </TableCellText>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
      <div css={buttonWrapperStyle}>
        <ButtonInternalLink to={".."}>Cancel</ButtonInternalLink>
      </div>
    </div>
  );
};
